import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8ce32a86"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "font-weight-bold mb-4" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-12 col-xl-5" }
const _hoisted_5 = { class: "card" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header bg-white" }, [
  /*#__PURE__*/_createElementVNode("h6", { class: "card-title" }, "Projektdaten")
], -1))
const _hoisted_7 = { class: "table table-borderless table-xs my-2" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "d-flex flex-row align-items-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "icon-hash mr-2" }),
  /*#__PURE__*/_createElementVNode("span", { class: "d-none d-md-block" }, " Project-Id:")
], -1))
const _hoisted_9 = { class: "text-right" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "d-flex flex-row align-items-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "icon-location4 mr-2" }),
  /*#__PURE__*/_createElementVNode("span", { class: "d-none d-md-block" }, " Geodaten:")
], -1))
const _hoisted_11 = { class: "text-right" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "d-flex flex-row align-items-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "icon-user mr-2" }),
  /*#__PURE__*/_createElementVNode("span", { class: "d-none d-md-block" }, " Name:")
], -1))
const _hoisted_13 = { class: "text-right" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_15 = { key: 0 }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "d-flex flex-row align-items-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "icon-map4 mr-2" }),
  /*#__PURE__*/_createElementVNode("span", { class: "d-none d-md-block" }, " Anschrift:")
], -1))
const _hoisted_18 = { class: "text-right" }
const _hoisted_19 = /*#__PURE__*/_createTextVNode()
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "d-flex flex-row align-items-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "icon-phone mr-2" }),
  /*#__PURE__*/_createElementVNode("span", { class: "d-none d-md-block" }, " Telefon:")
], -1))
const _hoisted_22 = { class: "text-right" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "d-flex flex-row align-items-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "icon-mention mr-2" }),
  /*#__PURE__*/_createElementVNode("span", { class: "d-none d-md-block" }, " Email:")
], -1))
const _hoisted_24 = { class: "text-right" }
const _hoisted_25 = { class: "col-12 col-xl-7" }
const _hoisted_26 = { class: "card" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header bg-white" }, [
  /*#__PURE__*/_createElementVNode("h6", { class: "card-title" }, "Alarmdetails")
], -1))
const _hoisted_28 = { class: "card-body" }
const _hoisted_29 = { class: "row" }
const _hoisted_30 = { class: "col-12" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("legend", { class: "text-uppercase font-size-sm font-weight-bold" }, " Zeitpunkt ", -1))
const _hoisted_32 = { key: 0 }
const _hoisted_33 = {
  key: 1,
  class: "alert bg-accent-100 border-accent text-accent"
}
const _hoisted_34 = { class: "col-12" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("legend", { class: "text-uppercase font-size-sm font-weight-bold" }, " Auslösegrund ", -1))
const _hoisted_36 = { key: 0 }
const _hoisted_37 = {
  key: 1,
  class: "alert bg-accent-100 border-accent text-accent"
}
const _hoisted_38 = { class: "col-12" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("legend", { class: "text-uppercase font-size-sm font-weight-bold" }, " Alarmbericht ", -1))
const _hoisted_40 = ["href"]
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-file-pdf" }, null, -1))
const _hoisted_42 = /*#__PURE__*/_createTextVNode(" Einsatzbericht ansehen")
const _hoisted_43 = [
  _hoisted_41,
  _hoisted_42
]
const _hoisted_44 = {
  key: 1,
  class: "alert bg-accent-100 border-accent text-accent"
}
const _hoisted_45 = { class: "col-12" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("legend", { class: "text-uppercase font-size-sm font-weight-bold" }, " Kontaktdaten Notruf- / Serviceleitstelle ", -1))
const _hoisted_47 = { class: "table table-borderless table-xs my-2" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "icon-hash mr-2" }),
  /*#__PURE__*/_createTextVNode(" Alarmid:")
], -1))
const _hoisted_49 = { class: "text-right" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", null, [
    /*#__PURE__*/_createElementVNode("i", { class: "icon-phone mr-2" }),
    /*#__PURE__*/_createTextVNode(" AVZ Notrufleitstelle:")
  ]),
  /*#__PURE__*/_createElementVNode("td", { class: "text-right" }, "0371 911 995 99")
], -1))
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "icon-person mr-2" }),
  /*#__PURE__*/_createTextVNode(" Ausgelöst durch:")
], -1))
const _hoisted_52 = { class: "text-right" }
const _hoisted_53 = { class: "col-12 col-xl-12" }
const _hoisted_54 = { class: "card" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header bg-white" }, [
  /*#__PURE__*/_createElementVNode("h6", { class: "card-title" }, "Videos")
], -1))
const _hoisted_56 = { class: "card-body" }
const _hoisted_57 = { class: "row" }
const _hoisted_58 = {
  key: 0,
  class: "col-12"
}
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "alert bg-accent-100 border-accent text-accent" }, "Keine Videos vorhanden", -1))
const _hoisted_60 = [
  _hoisted_59
]
const _hoisted_61 = { class: "card" }
const _hoisted_62 = { class: "card-img-actions mx-1 mt-1" }
const _hoisted_63 = {
  key: 0,
  class: "card-img embed-responsive embed-responsive-16by9"
}
const _hoisted_64 = {
  width: "320",
  height: "240",
  controls: ""
}
const _hoisted_65 = ["src"]
const _hoisted_66 = ["src"]
const _hoisted_67 = /*#__PURE__*/_createTextVNode(" Your browser does not support the video tag. ")
const _hoisted_68 = {
  key: 1,
  class: "card-img embed-responsive gif-image-box"
}
const _hoisted_69 = ["src"]
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-body" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-start flex-nowrap" }, [
    /*#__PURE__*/_createElementVNode("div", null, [
      /*#__PURE__*/_createElementVNode("div", { class: "font-weight-semibold mr-2" }, "Video")
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "list-icons list-icons-extended ml-auto" })
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, [
      _createTextVNode(_toDisplayString(_ctx.headline) + " ", 1),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-secondary float-right",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.showDetail && _ctx.showDetail(...args)))
      }, "Alle Daten")
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("table", _hoisted_7, [
            _createElementVNode("tbody", null, [
              _createElementVNode("tr", null, [
                _hoisted_8,
                _createElementVNode("td", _hoisted_9, _toDisplayString(_ctx.details.pid), 1)
              ]),
              _createElementVNode("tr", null, [
                _hoisted_10,
                _createElementVNode("td", _hoisted_11, _toDisplayString(_ctx.details.geodatenGenau), 1)
              ]),
              _createElementVNode("tr", null, [
                _hoisted_12,
                _createElementVNode("td", _hoisted_13, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.details.p_anrede), 1),
                  _hoisted_14,
                  (_ctx.details.p_firma != '')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(_ctx.details.p_firma), 1))
                    : _createCommentVNode("", true),
                  _hoisted_16,
                  _createElementVNode("span", null, _toDisplayString(_ctx.details.p_vorname) + " " + _toDisplayString(_ctx.details.p_name), 1)
                ])
              ]),
              _createElementVNode("tr", null, [
                _hoisted_17,
                _createElementVNode("td", _hoisted_18, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.details.p_strasse) + " " + _toDisplayString(_ctx.details.p_hnr), 1),
                  _hoisted_19,
                  _hoisted_20,
                  _createElementVNode("span", null, _toDisplayString(_ctx.details.p_plz) + " " + _toDisplayString(_ctx.details.p_ort), 1)
                ])
              ]),
              _createElementVNode("tr", null, [
                _hoisted_21,
                _createElementVNode("td", _hoisted_22, _toDisplayString(_ctx.details.p_tel), 1)
              ]),
              _createElementVNode("tr", null, [
                _hoisted_23,
                _createElementVNode("td", _hoisted_24, _toDisplayString(_ctx.details.p_email), 1)
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_25, [
        _createElementVNode("div", _hoisted_26, [
          _hoisted_27,
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("div", _hoisted_30, [
                _hoisted_31,
                (_ctx.reason)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_32, _toDisplayString(_ctx.details.createdAt) + " Uhr", 1))
                  : (_openBlock(), _createElementBlock("div", _hoisted_33, " Leider wurde kein Auslösezeitpunkt angegeben "))
              ]),
              _createElementVNode("div", _hoisted_34, [
                _hoisted_35,
                (_ctx.reason)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_36, _toDisplayString(_ctx.reason), 1))
                  : (_openBlock(), _createElementBlock("div", _hoisted_37, " Leider wurde kein Auslösegrund angegeben "))
              ]),
              _createElementVNode("div", _hoisted_38, [
                _hoisted_39,
                (_ctx.details.einsatzbericht_pdf)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      href: _ctx.details.einsatzbericht_pdf,
                      target: "_blank",
                      class: "btn btn-secondary"
                    }, _hoisted_43, 8, _hoisted_40))
                  : (_openBlock(), _createElementBlock("div", _hoisted_44, " Es ist leider kein Einsatzbericht vorhanden "))
              ]),
              _createElementVNode("div", _hoisted_45, [
                _hoisted_46,
                _createElementVNode("table", _hoisted_47, [
                  _createElementVNode("tbody", null, [
                    _createElementVNode("tr", null, [
                      _hoisted_48,
                      _createElementVNode("td", _hoisted_49, _toDisplayString(_ctx.details.alarm_id), 1)
                    ]),
                    _hoisted_50,
                    _createElementVNode("tr", null, [
                      _hoisted_51,
                      _createElementVNode("td", _hoisted_52, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.triggeredBy?.anrede) + " " + _toDisplayString(_ctx.triggeredBy?.vorname?.charAt(0)) + ". " + _toDisplayString(_ctx.triggeredBy?.name), 1)
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_53, [
        _createElementVNode("div", _hoisted_54, [
          _hoisted_55,
          _createElementVNode("div", _hoisted_56, [
            _createElementVNode("div", _hoisted_57, [
              (_ctx.videos.length <= 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_58, _hoisted_60))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.videos, (video, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "col-12 col-md-6 col-xl-4"
                }, [
                  _createElementVNode("div", _hoisted_61, [
                    _createElementVNode("div", _hoisted_62, [
                      (video.type == 'mp4')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                            _createElementVNode("video", _hoisted_64, [
                              _createElementVNode("source", {
                                src: video.url,
                                type: "video/mp4"
                              }, null, 8, _hoisted_65),
                              _createElementVNode("source", {
                                src: video.url,
                                type: "video/ogg"
                              }, null, 8, _hoisted_66),
                              _hoisted_67
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (video.type == 'gif')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
                            _createElementVNode("img", {
                              src: video.url
                            }, null, 8, _hoisted_69)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _hoisted_70
                  ])
                ]))
              }), 128))
            ])
          ])
        ])
      ])
    ])
  ]))
}